import Sport from './Sport'

export default class Discipline {
  constructor (data) {
    this.id = data.id
    this.sportId = data.sportId
    this.nameFr = data.nameFr
    this.team = data.team

    this.sport = data.sport ? new Sport(data.sport) : null
  }
}
